import { PropertyStateFields, ReportFeatures } from '@hcs/types';

export const DEFAULT_COLS: PropertyStateFields[][] = [
  [
    PropertyStateFields.livingArea,
    PropertyStateFields.livingAreaAboveGrade,
    PropertyStateFields.livingAreaBelowGrade,
    PropertyStateFields.lotSize,
    PropertyStateFields.bedrooms,
    PropertyStateFields.bathrooms,
    PropertyStateFields.stories,
    PropertyStateFields.propertyType,
    PropertyStateFields.ownerOccupied,
    PropertyStateFields.yearBuilt,
    PropertyStateFields.basementHas,
    PropertyStateFields.pool,
    PropertyStateFields.daysOnMarketCumulative,
    PropertyStateFields.apn,
    PropertyStateFields.concessions,
    PropertyStateFields.concessionSellerAmount,
    PropertyStateFields.concessionSellerDescription,
  ],
  [
    PropertyStateFields.garageType,
    PropertyStateFields.garageSpaces,
    PropertyStateFields.condition,
    PropertyStateFields.subdivisionName,
    PropertyStateFields.zoning,
    PropertyStateFields.associationName,
    PropertyStateFields.associationFee,
    PropertyStateFields.associationFeeFrequency,
    PropertyStateFields.associationFeeIncludes,
    PropertyStateFields.taxYear,
    PropertyStateFields.taxAmount,
    PropertyStateFields.county,
    PropertyStateFields.concessionsAmount,
    PropertyStateFields.concessionBuyerAmount,
    PropertyStateFields.concessionBuyerDescription,
    PropertyStateFields.concessionsComments,
  ],
];
export const dataHcEventSectionEditSubjectDetails =
  'Edit Subject Property Details';
export const SUBJECT_DETAILS_TABLE_FEATURES = [
  ReportFeatures.SubjectPropertyDetails,
  ReportFeatures.SubjectEditDetails,
  ReportFeatures.SubjectEditCondition,
];
